import { tsValidateString, tsValidateUniqueId, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
const Validator_ModifiableProps = {
    encounterId: tsValidateUniqueId,
    patientId: tsValidateUniqueId,
    EHRInstanceId: tsValidateUniqueId,
    sessionData: {
        patient_id: tsValidateString(),
        encounter_id: tsValidateString(),
        access_token: tsValidateString(),
        user_id: tsValidator_nonMandatoryString,
    }
};
const Validator_GeneratedProps = {};
export const DBDef_AdvisorSession = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'advisor-sessions',
    entityName: 'AdvisorSession',
    frontend: {
        group: 'advisor',
        name: 'session'
    },
    backend: {
        name: 'advisor-sessions'
    }
};
//# sourceMappingURL=db-def.js.map